/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Aria_Toggle_SectionInputs */

const vi_common_aria_toggle_section = /** @type {(inputs: Common_Aria_Toggle_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mở/đóng phần`)
};

/**

* @param {Common_Aria_Toggle_SectionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const common_aria_toggle_section = /** @type {((inputs?: Common_Aria_Toggle_SectionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Aria_Toggle_SectionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_common_aria_toggle_section(inputs)
});